import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import './ForgotPassword.css';

function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');
    setMessage('');
    
    try {
      const response = await axios.post('https://hub2.daolog.net/forgot-password', { email });
      setMessage(response.data.message || 'Інструкції для відновлення паролю відправлено на email');
    } catch (err) {
      setError(err.response?.data?.message || 'Сталася помилка при відправці запиту');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="forgot-password-page">
      <div className="forgot-password-container">
        <div className="forgot-password-header">
          <h1 className="forgot-password-title">Відновлення паролю</h1>
          <p className="forgot-password-subtitle">
            Введіть email, пов'язаний з вашим акаунтом, і ми надішлемо вам інструкції для відновлення паролю.
          </p>
        </div>
        
        <div className="forgot-password-card">
          <form onSubmit={handleSubmit} className="forgot-password-form">
            <div className="form-group">
              <label htmlFor="email" className="form-label">
                Email акаунту
              </label>
              <input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="your.email@example.com"
                required
                className="form-input"
                disabled={isLoading}
              />
            </div>
            
            {message && (
              <div className="success-message">
                <svg className="success-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9 12L11 14L15 10M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" 
                    stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                {message}
              </div>
            )}
            
            {error && (
              <div className="error-message">
                <svg className="error-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 8V12M12 16H12.01M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" 
                    stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                {error}
              </div>
            )}
            
            <button 
              type="submit" 
              className="submit-button"
              disabled={isLoading}
            >
              {isLoading ? (
                <span className="button-loading">
                  <span className="spinner"></span>
                  Відправка...
                </span>
              ) : (
                'Надіслати інструкції'
              )}
            </button>
            
            <div className="forgot-password-footer">
              <button 
                type="button"
                className="back-to-login-button"
                onClick={() => navigate('/login')}
              >
                ← Повернутися до входу
              </button>
            </div>
          </form>
        </div>
        
        <div className="additional-info">
          <p>
            Не отримали email? Перевірте папку "Спам" або{' '}
            <button 
              className="try-again-button"
              onClick={() => {
                setError('');
                setMessage('');
              }}
            >
              спробуйте ще раз
            </button>
          </p>
        </div>
      </div>
    </div>
  );
}

export default ForgotPassword;